import type { WorkflowRunPayload } from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunFetched';

/** `202`: the run, now generating. */
export type WorkflowRunGenerationLaunchedAction = {
	type: 'WORKFLOW_RUN_GENERATION_LAUNCHED';
	payload: WorkflowRunPayload;
	facilityId: number;
	typeKey: string;
	subjectId: number;
};

export default (
	payload: WorkflowRunPayload,
	facilityId: number,
	typeKey: string,
	subjectId: number,
): WorkflowRunGenerationLaunchedAction => ({
	type: 'WORKFLOW_RUN_GENERATION_LAUNCHED',
	payload,
	facilityId,
	typeKey,
	subjectId,
});
